import { floatParser } from "shared/components/forms/BaseInput/parsers";

export const salePriceParser = floatParser({ maxDecimals: 2 });

// AppFolio-sourced fee inputs operate in integer cents. $10,000 cap mirrors
// the Listing-template fee inputs (MAX_FEE_CENTS).
export const APPFOLIO_FEE_MAX_CENTS = 1_000_000;

export const RENT_PMS_SYNCED = `Rent amount is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const RENT_PMS_UNSYNCED = `Rent amount is currently edited manually. You can enable
synchronization by clicking 'Sync with PMS' option`;

export const SALE_PRICE_PMS_SYNCED = `Sale price is synchronized with PMS. You can manually edit
  the field by disabling synchronization for this field. To do
  this, click 'Edit manually' option`;

export const SALE_PRICE_PMS_UNSYNCED = `Sale price is currently edited manually. You can enable
synchronization by clicking 'Sync with PMS' option`;
